import { Typography } from "@material-ui/core";

function ViewFooterNote(props) {
	return (
		<Typography className={" text-10 md:text-11 py-5 mt-5 text-gray-400 " + props.className}>{props.text}</Typography>
	);
}

export default ViewFooterNote;
